import type { MarketId } from '@morpho-org/blue-sdk'

/**
 * Sole market-ID validator for the app — procedure input, discovery row parsing, and the manual
 * market-ID form all key off this.
 *
 * Deliberately not `@repo/utils`' `marketIdSchema`: that pipes through `hexSchema` and therefore
 * transforms, which `@repo/cache` cannot accept on a cache unit's `input` schema (see
 * `lib/orpc/schemas.ts`). Kept zod-free so the client form can import it without pulling zod into
 * the browser bundle; the zod wrapper lives in `lib/orpc/schemas.ts`.
 */
const MARKET_ID_RE = /^0x[\da-fA-F]{64}$/

export function isMarketId(value: unknown): value is MarketId {
  return typeof value === 'string' && MARKET_ID_RE.test(value)
}
